__turbopack_context__.v({
  "Cont": "Hero-module-sass-module__47fXdq__Cont",
  "Details": "Hero-module-sass-module__47fXdq__Details",
  "Hero": "Hero-module-sass-module__47fXdq__Hero",
  "Image": "Hero-module-sass-module__47fXdq__Image",
  "Main": "Hero-module-sass-module__47fXdq__Main",
});
